import { render } from "./UserRegistrationChart.vue?vue&type=template&id=7fda2437&scoped=true&ts=true"
import script from "./UserRegistrationChart.vue?vue&type=script&lang=ts"
export * from "./UserRegistrationChart.vue?vue&type=script&lang=ts"

import "./UserRegistrationChart.vue?vue&type=style&index=0&id=7fda2437&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fda2437"]])

export default __exports__